<template>
  <div>
    <h1 class="page-title">反馈管理</h1>

    <div class="query-panel soft-card">
      <div class="query-fields">
        <el-input v-model="query.content" clearable placeholder="反馈内容" class="query-control" @keyup.enter.native="search" />
        <el-input v-model="query.contactName" clearable placeholder="反馈联系人" class="query-control" @keyup.enter.native="search" />
        <el-input v-model="query.contactPhone" clearable placeholder="反馈联系电话" class="query-control" @keyup.enter.native="search" />
        <el-input v-model="query.nickname" clearable placeholder="姓名/昵称" class="query-control" @keyup.enter.native="search" />
        <el-input v-model="query.username" clearable placeholder="登录账号" class="query-control" @keyup.enter.native="search" />
        <el-input v-model="query.phone" clearable placeholder="手机号" class="query-control" @keyup.enter.native="search" />
        <el-input v-model="query.companyName" clearable placeholder="企业名称" class="query-control" @keyup.enter.native="search" />
        <el-select v-model="query.feedbackType" clearable placeholder="反馈类型" class="query-control">
          <el-option label="投诉" value="投诉" />
          <el-option label="建议" value="建议" />
        </el-select>
        <el-select v-model="query.status" clearable placeholder="处理状态" class="query-control">
          <el-option label="待处理" value="待处理" />
          <el-option label="已处理" value="已处理" />
        </el-select>
      </div>
      <div class="query-actions">
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh-left" @click="resetQuery">重置</el-button>
      </div>
    </div>

    <div class="table-toolbar">
      <el-button type="danger" plain icon="el-icon-delete" :disabled="selectedRows.length === 0" @click="batchRemove">
        批量删除{{ selectedRows.length ? `（${selectedRows.length}）` : '' }}
      </el-button>
    </div>

    <el-table class="soft-card" :data="list" v-loading="loading" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" />
      <el-table-column type="index" label="序号" width="70" :index="tableIndex" />
      <el-table-column prop="feedbackType" label="类型" width="90" />
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === '待处理' ? 'warning' : 'success'">{{ scope.row.status }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="content" label="反馈内容" min-width="250" show-overflow-tooltip />
      <el-table-column prop="nickname" label="姓名/昵称" min-width="120" show-overflow-tooltip />
      <el-table-column prop="username" label="登录账号" min-width="120" show-overflow-tooltip />
      <el-table-column prop="phone" label="手机号" width="130" />
      <el-table-column prop="companyName" label="企业名称" min-width="150" show-overflow-tooltip />
      <el-table-column prop="contactName" label="反馈联系人" width="120" />
      <el-table-column prop="contactPhone" label="反馈联系电话" width="140" />
      <el-table-column prop="createdAt" label="提交时间" width="170" />
      <el-table-column label="操作" width="190" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="openDetail(scope.row)">查看</el-button>
          <el-button v-if="scope.row.status === '已处理'" type="text" size="mini" @click="restorePending(scope.row)">改回待处理</el-button>
          <el-button type="text" size="mini" class="danger-text" @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-wrap">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page="query.pageNum"
        :page-size="query.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </div>

    <el-dialog v-if="detailVisible" :close-on-click-modal="false" custom-class="manage-dialog" title="反馈详情" :visible.sync="detailVisible" width="720px">
      <div v-if="current" class="detail-box">
        <div class="detail-row"><span>反馈类型</span><b>{{ current.feedbackType }}</b></div>
        <div class="detail-row"><span>处理状态</span><b>{{ current.status }}</b></div>
        <div class="detail-row"><span>姓名/昵称</span><b>{{ current.nickname || '' }}</b></div>
        <div class="detail-row"><span>登录账号</span><b>{{ current.username || '' }}</b></div>
        <div class="detail-row"><span>手机号</span><b>{{ current.phone || '' }}</b></div>
        <div class="detail-row"><span>企业名称</span><b>{{ current.companyName || '' }}</b></div>
        <div class="detail-row"><span>反馈联系人</span><b>{{ current.contactName || '' }}</b></div>
        <div class="detail-row"><span>反馈联系电话</span><b>{{ current.contactPhone || '' }}</b></div>
        <div class="detail-row detail-row-block"><span>反馈内容</span><b class="multiline-text">{{ current.content }}</b></div>
        <el-input v-model="remark" type="textarea" :rows="3" placeholder="处理备注，仅后台可见，可不填" :disabled="isCurrentDone" />
      </div>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
        <el-button v-if="!isCurrentDone" type="primary" @click="saveStatus">标记已处理</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { batchDeleteFeedback, deleteFeedback, listFeedback, updateFeedbackStatus } from '../api'

export default {
  data() {
    return {
      query: {
        content: '',
        contactName: '',
        contactPhone: '',
        nickname: '',
        username: '',
        phone: '',
        companyName: '',
        feedbackType: '',
        status: '',
        pageNum: 1,
        pageSize: 10
      },
      list: [],
      total: 0,
      loading: false,
      selectedRows: [],
      detailVisible: false,
      current: null,
      remark: ''
    }
  },
  computed: {
    isCurrentDone() {
      return !!(this.current && this.current.status === '已处理')
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      listFeedback(this.query)
        .then(result => {
          this.list = result && result.records ? result.records : []
          this.total = result && typeof result.total === 'number' ? result.total : 0
        })
        .finally(() => {
          this.loading = false
        })
    },
    search() {
      this.query.pageNum = 1
      this.load()
    },
    resetQuery() {
      this.query.content = ''
      this.query.contactName = ''
      this.query.contactPhone = ''
      this.query.nickname = ''
      this.query.username = ''
      this.query.phone = ''
      this.query.companyName = ''
      this.query.feedbackType = ''
      this.query.status = ''
      this.query.pageNum = 1
      this.load()
    },
    tableIndex(index) {
      return (this.query.pageNum - 1) * this.query.pageSize + index + 1
    },
    handlePageChange(pageNum) {
      this.query.pageNum = pageNum
      this.load()
    },
    handleSizeChange(pageSize) {
      this.query.pageSize = pageSize
      this.query.pageNum = 1
      this.load()
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows
    },
    openDetail(row) {
      this.current = row
      this.remark = row.remark || ''
      this.detailVisible = true
    },
    saveStatus() {
      if (!this.current) return
      updateFeedbackStatus({ id: this.current.id, status: '已处理', remark: this.remark }).then(() => {
        this.$message.success('已标记处理')
        this.detailVisible = false
        this.load()
      })
    },
    restorePending(row) {
      this.$confirm('改回待处理会清空本次处理备注，确认继续吗？', '状态确认', { type: 'warning' })
        .then(() => updateFeedbackStatus({ id: row.id, status: '待处理' }))
        .then(() => {
          this.$message.success('已改回待处理')
          this.load()
        })
        .catch(() => {})
    },
    remove(row) {
      this.$confirm('确认删除这条反馈记录吗？删除后不可恢复。', '删除确认', { type: 'warning' })
        .then(() => deleteFeedback({ id: row.id }))
        .then(() => {
          this.$message.success('已删除')
          this.recoverPageIfNeeded(1)
          this.load()
        })
        .catch(() => {})
    },
    batchRemove() {
      const ids = this.selectedRows.map(item => item.id)
      this.$confirm(`确认删除选中的 ${ids.length} 条反馈记录吗？删除后不可恢复。`, '批量删除确认', { type: 'warning' })
        .then(() => batchDeleteFeedback({ ids }))
        .then(() => {
          this.$message.success('批量删除成功')
          this.recoverPageIfNeeded(ids.length)
          this.load()
        })
        .catch(() => {})
    },
    recoverPageIfNeeded(deletedCount) {
      if (this.list.length <= deletedCount && this.query.pageNum > 1) {
        this.query.pageNum -= 1
      }
    }
  }
}
</script>

<style scoped>
.pagination-wrap { display: flex; justify-content: flex-end; margin: 18px 0 4px; }
.query-panel { padding: 18px; margin-bottom: 14px; }
.query-fields { display: flex; flex-wrap: wrap; gap: 12px; }
.query-actions { display: flex; justify-content: flex-end; gap: 12px; margin-top: 16px; }
.query-control { width: 220px; }
.table-toolbar { display: flex; justify-content: flex-start; margin-bottom: 16px; }
.danger-text { color: #f56c6c; }
.detail-box { color: #314057; border: 1px solid #edf2f7; border-radius: 14px; overflow: hidden; }
.detail-row { display: flex; justify-content: space-between; gap: 16px; padding: 10px 16px; border-bottom: 1px solid #edf2f7; line-height: 1.7; }
.detail-row span { flex: 0 0 72px; color: #7a8798; }
.detail-row b { color: #2f3f57; font-weight: 500; text-align: right; }
.detail-row-block { align-items: flex-start; }
.detail-row-block b { text-align: left; flex: 1; }
.multiline-text { white-space: pre-wrap; word-break: break-word; }
.detail-box .el-textarea { display: block; padding: 16px; }
</style>
